export enum BOTTOM_BUTTONS {
  END_TURN = -2,
  MISS
}

export enum DART_HITS {
  SINGLE = 1,
  DOUBLE = 2,
  TRIPLE = 3
}

export enum DART_NUMBER {
  ONE = 1,
  TWO,
  THREE,
  FOUR,
  FIVE,
  SIX,
  SEVEN,
  EIGHT,
  NINE,
  TEN,
  ELEVEN,
  TWELVE,
  THIRTEEN,
  FOURTEEN,
  FIFTEEN,
  SIXTEEN,
  SEVENTEEN,
  EIGHTEEN,
  NINETEEN,
  TWENTY,
  BULL = 25
}


export interface Dart {
  number: DART_NUMBER | BOTTOM_BUTTONS;
  multiplier: DART_HITS | BOTTOM_BUTTONS;
}

export enum CRICKET_NUMBERS {
  FIFTEEN = 15,
  SIXTEEN,
  SEVENTEEN,
  EIGHTEEN,
  NINETEEN,
  TWENTY,
  BULL = 25
}

export enum CRICKET_MARK_ASP {
  FIVE = 5,
  SIX,
  SEVEN,
  EIGHT,
  NINE,
}

export enum CRICKET_BULL_ASP {
  THREE = 3,
  FOUR,
  FIVE,
  SIX
}

export enum X01_ASP {
  TWENTY_SIX = 26,
  TON = 100,
  TON_TWENTY = 120,
  TON_FORTY = 140,
  TON_SIXTY = 160,
  TON_EIGHTY = 180
}

export enum COLOR {
  WHITE = "White",
  BLACK = "Black",
  RED = "Red",
  GREEN = "Green"
}

interface DartColor {
  [COLOR.WHITE]: Dart[];
  [COLOR.BLACK]: Dart[];
  [COLOR.RED]: Dart[];
  [COLOR.GREEN]: Dart[];
}

export const DART_COLOR: DartColor = {
  [COLOR.WHITE]: [
    {
      number: DART_NUMBER.ONE,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.FOUR,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.FIVE,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.SIX,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.NINE,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.ELEVEN,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.FIFTEEN,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.SIXTEEN,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.SEVENTEEN,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.NINETEEN,
      multiplier: DART_HITS.SINGLE,
    }
  ],
  [COLOR.BLACK]: [
    {
      number: DART_NUMBER.TWO,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.THREE,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.SEVEN,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.EIGHT,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.TEN,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.TWELVE,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.THIRTEEN,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.FOURTEEN,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.EIGHTEEN,
      multiplier: DART_HITS.SINGLE,
    }, {
      number: DART_NUMBER.TWENTY,
      multiplier: DART_HITS.SINGLE,
    }
  ],
  [COLOR.RED]: [
    {
      number: DART_NUMBER.TWO,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.THREE,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.SEVEN,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.EIGHT,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.TEN,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.TWELVE,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.THIRTEEN,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.FOURTEEN,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.EIGHTEEN,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.TWENTY,
      multiplier: DART_HITS.DOUBLE,
    }
  ],
  [COLOR.GREEN]: [
    {
      number: DART_NUMBER.ONE,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.FOUR,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.FIVE,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.SIX,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.NINE,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.ELEVEN,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.FIFTEEN,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.SIXTEEN,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.SEVENTEEN,
      multiplier: DART_HITS.DOUBLE,
    }, {
      number: DART_NUMBER.NINETEEN,
      multiplier: DART_HITS.DOUBLE,
    }
  ],
}

export type CRICKET_ASP = (CRICKET_BULL_ASP | CRICKET_MARK_ASP)[];

export type DartNumber = DART_NUMBER | CRICKET_NUMBERS | BOTTOM_BUTTONS;